import React, { useEffect, useContext, useState } from 'react'
import { useParams } from 'react-router-dom';
import ImageGallery from '../components/layout/ImageGallery';
import RelatedCard from '../components/RelatedCard';
import ProductContext from '../context/products/ProductContext'
import Spinner from '../components/layout/Spinner'
import ProductNotFound from '../components/layout/ProductNotFound';
import ScrollToTop from '../components/ScrollToTop'
import { Helmet } from 'react-helmet';
import { trackAddToCart } from '../utils/pixel.jsx';

function Oil() {
  const { oil,
    loading,
    relatedProducts,
    fetchOil,
    fetchRelatedProducts,
    addToCart } = useContext(ProductContext)

  const [quantity, setQuantity] = useState(oil.stock <= 0 ? 0 : 1);
  const initialStock = oil.stock && !isNaN(oil.stock) ? oil.stock : 0;

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      fetchOil(id);
      fetchRelatedProducts();
    }
  }, [id]);

  const handleInput = (e) => {
    let value = parseInt(e.target.value);

    if (isNaN(value) || value <= 0) {
      value = 1;
    }

    if (value > initialStock) {
      value = initialStock;
    }

    setQuantity(value);
  };

  const handleButtonClick = (action) => {
    setQuantity((prevQuantity) => {
      if (action === 'increment' && prevQuantity < oil.stock) {
        return prevQuantity + 1;
      } else if (action === 'decrement' && prevQuantity > 1) {
        return prevQuantity - 1;
      }
      return prevQuantity;
    });
  };

  const pageTitle = `${oil.title} | Масло за автомобили`;
  const pageDescription = `Купете ${oil.title} со вискозитет ${oil.saeViscosity}. Најдете го со најдобра цена во нашата онлајн продавница.`;
  const pageKeywords = `${oil.title}, ${oil.manufacturer}, ${oil.saeViscosity}, ${oil.capacity}, масло, уље, моторни масла, уље за кола, масло за кола`;


  if (loading) {
    return <Spinner />;
  }

  if (!oil && !loading) {
    return <ProductNotFound />
  }

  return (
    <>
      <ScrollToTop />

       <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={oil.imageUrl} /> {/* You can dynamically set image URL */}
        <meta property="og:type" content="product" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={oil.imageUrl} />
      </Helmet>


      {oil.id && !loading && (<div className="container mx-auto p-4">
        <h1 className="text-3xl font-bold mb-4">{oil.title}</h1>
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-1/3">
            {oil && Object.keys(oil).length > 0 && (
              <ImageGallery key={oil.id} item={oil} />
            )}
          </div>
          <div className='flex-1'>
            <div className="overflow-x-auto">
              <table className="table ">
                {/* head */}
                <thead>
                  <tr>
                    <th>Опис на производот</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="odd:bg-white even:bg-gray-200">
                    <td>Капацитет</td>
                    <td>{oil.capacity} L</td>
                  </tr>
                  <tr className="odd:bg-white even:bg-gray-200">
                    <td>Препораки (Recommendations): </td>
                    <td>{oil.recomendations}</td>
                  </tr>
                  {oil.specification !== ' ' &&
                    <tr className="odd:bg-white even:bg-gray-200">
                      <td>Спецификација</td>
                      <td>{oil.specification}</td>
                    </tr>}
                  <tr className="odd:bg-white even:bg-gray-200">
                    <td>Вискозитет</td>
                    <td>{oil.saeViscosity}</td>
                  </tr>
                  {oil.version !== ' ' &&
                    <tr className="odd:bg-white even:bg-gray-200">
                      <td>Верзија</td>
                      <td>{oil.version}</td>
                    </tr>
                  }
                  {
                    oil.itemNumber !== ' ' &&
                    <tr className="odd:bg-white even:bg-gray-200">
                      <td>Број на производот</td>
                      <td>{oil.itemNumber}</td>
                    </tr>
                  }
                  <tr className="odd:bg-white even:bg-gray-200">
                    <td>Производител</td>
                    <td>{oil.manufacturer}</td>
                  </tr>
                  {oil.eanNumber !== ' ' &&
                    <tr className="odd:bg-white even:bg-gray-200">
                      <td>EAN број</td>
                      <td>{oil.eanNumber}</td>
                    </tr>
                  }

                </tbody>
              </table>
              <p className="text-2xl text-red-600 font-semibold mb-2">
                {oil.discountedPrice > 0 ? (
                  <>
                    <span className="line-through text-gray-500 text-[16px] mr-2">{oil.price}</span>
                    <span>{oil.discountedPrice} ден</span>
                  </>
                ) : (
                  <span>{oil.price} ден</span>
                )}
              </p>
              <div className="flex items-center space-x-4">
                <div className="py-2 px-3 inline-block bg-white border border-gray-200 rounded-lg dark:bg-neutral-900 dark:border-neutral-700">
                  <div className="flex items-center gap-x-1.5">
                    <button
                      type="button"
                      className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                      tabIndex="-1"
                      aria-label="Decrease"
                      onClick={() => handleButtonClick('decrement')}
                      disabled={oil.stock == 0}
                    >
                      <svg className="shrink-0 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14"></path>
                      </svg>
                    </button>
                    <input
                      id="quantity"
                      type="number"
                      className="p-0 w-8 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white"
                      style={{
                        MozAppearance: 'textfield',
                        WebkitAppearance: 'none',
                      }}
                      value={quantity}
                      onInput={handleInput}
                      min={1}
                      max={oil.stock}
                      disabled={oil.stock == 0}
                    />
                    <button
                      type="button"
                      className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                      tabIndex="-1"
                      aria-label="Increase"
                      onClick={() => handleButtonClick('increment')}
                      disabled={oil.stock == 0}
                    >
                      <svg className="shrink-0 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14"></path>
                        <path d="M12 5v14"></path>
                      </svg>
                    </button>
                  </div>
                </div>

                <div>
                  <button className="btn btn-secondary btn-sm text-gray-300" disabled={oil.stock <= 0} onClick={() => {addToCart(oil, quantity); trackAddToCart(oil.title, oil.price)}}>{oil.stock <= 0 ? (<span>Нема залиха</span>) : (<span>Додади во кошничка</span>)}</button>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1">
            {/* <p className="mb-4">
              {oil.description}
            </p> */}
            <div dangerouslySetInnerHTML={{ __html: oil.description }} />

          </div>
        </div>
        <div>
          <h2 className='text-2xl font-bold mt-[10%] text-center mb-10'>Поврзани производи</h2>
          <div
            className='flex flex-wrap gap-12 justify-center'
          >
            {!relatedProducts || relatedProducts.length === 0 ? (
              <p>Нема поврзани производи за прикажување</p>
            ) : relatedProducts.map((prod) => (
              <div key={prod.id}>
                <RelatedCard key={prod.id} item={prod} />
              </div>
            ))
            }
          </div>
        </div>
      </div>)}
    </>
  )
}



export default Oil